module.exports = __webpack_public_path__ + "static/media/ic_swap.8063a6db.svg";